import * as types from './types';

export const getDefaultLandingPage = () => ({
  type: types.GET_DEFAULT_LANDING_PAGE,
});

export const setDefaultLandingPage = payload => ({
  type: types.SET_DEFAULT_LANDING_PAGE,
  payload,
});

export const updateDefaultLandingPage = payload => ({
  type: types.UPDATE_DEFAULT_LANDING_PAGE,
  payload,
});

export const setDefaultLandingPagePromptTitle = payload => ({
  type: types.SET_PROMPT_TITLE,
  payload,
});

export const setDefaultLandingPagePromptContent = payload => ({
  type: types.SET_PROMPT_CONTENT,
  payload,
});

export const setDefaultLandingPagePromptNeedInput = payload => ({
  type: types.SET_PROMPT_NEED_INPUT,
  payload,
});

export const setDefaultLandingPagePromptOkFn = payload => ({
  type: types.SET_PROMPT_OK_FN,
  payload,
});

export const showPrompt = () => ({
  type: types.SHOW_PROMPT,
});

export const hidePrompt = () => ({
  type: types.HIDE_PROMPT,
});

export const setTmpPayload = payload => ({
  type: types.SET_TMP_PAYLOAD,
  payload,
});

export const setCustomerId = payload => ({
  type: types.SET_CUSTOMER_ID,
  payload,
});
